// @flow
const LABELS = {
  web: 'Web',
  ios: 'iOS',
  android: 'Android',
  html: 'HTML',
  react: 'React',
  swift: 'Swift',
  objc: 'Objective-C',
  javaclient: 'Java',
  kotlin: 'Kotlin',
  node: 'Node',
  java: 'Java',
  ruby: 'Ruby',
  python: 'Python',
  php: 'PHP',
  go: 'Go',
  dotnet: '.NET',
  javascript: 'JavaScript',
  js: 'JavaScript',
  esnext: 'ESNext',
  next: 'Next.js',
  m2: 'Reader M2',
  wpe: 'WisePOS E',
  wp3: 'WisePad 3',
  US: 'United States',
  CA: 'Canada',
  GB: 'United Kingdom',
  IE: 'Ireland',
  FR: 'France',
  DE: 'Germany',
  NL: 'Netherlands',
  AU: 'Australia',
  SG: 'Singapore',
  NZ: 'New Zealand',
  AT: 'Austria',
  BE: 'Belgium',
  DK: 'Denmark',
  ES: 'Spain',
  SE: 'Sweden',
  IT: 'Italy',
  LU: 'Luxembourg',
  PT: 'Portugal',
  NO: 'Norway',
  FI: 'Finland',
  CH: 'Switzerland',
};

export const formatLanguage = (language: string): string => {
  return LABELS[language] || language;
};
